
interface CompanyBioCardProps {
  bio: string | null | undefined;
}

export function CompanyBioCard({ bio }: CompanyBioCardProps) {
  return (
    <div>
      <h3 className="text-lg font-medium mb-2">Company Bio</h3>
      <p>{bio || 'No bio provided.'}</p>
    </div>
  );
}
